import "./pricingcard.css";
import {Link} from "react-router-dom";

import React from 'react'

const PricingCard = () => {
  return (
    <div className="pricing">
        <div className="card-container">
            <div className ="card">
                <h3>- Basic -</h3>
                <span className="bar"></span>
                <p className="btc"> Rs 1000</p>
                <p>-3 Days -</p>
                <p>-3 Pages -</p>
                <p>-Featured-</p>
                <p>-Responsive Design</p>
                <Link to ="/about" className="btn">Go to Purchase Now</Link>
            </div>
{/* second card */}

            <div className ="card">
                <h3>- Premium -</h3>
                <span className="bar"></span>
                <p className="btc"> Rs 3000</p>
                <p>2 Days -</p>
                <p>-5 Pages -</p>
                <p>-Featured-</p>
                <p>-Responsive Design</p>
                <Link to ="/about" className="btn">Go to Purchase Now</Link>
            </div>

{/* third card  */}
 
        <div className ="card">
                <h3>- Buisness -</h3>
                <span className="bar"></span>
                <p className="btc"> Rs 5000</p>
                <p>-5 Days -</p>
                <p>-8 Pages -</p>
                <p>-Featured-</p>
                <p>-Responsive Design</p>
                <Link to ="/about" className="btn">Go to Purchase Now</Link>
            </div>

        </div>
    </div>
  )
}

export default PricingCard